import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import useToastMsg from '../../common/useToastMsg';
import { CATEGORY } from '../../../constants/queryKeys';
import categoryToastMsg from '../../../constants/service/toastMsg/categoryToastMsg';

/**
 * 카테고리 리스트 트리를 불러오는 query hook
 * @param options
 * @return {UseQueryResult<AxiosResponse<any>, unknown>}
 */
const useCategoryListTree = (options) => {
  const { search } = useLocation();
  const { success, error } = useToastMsg();

  return useQuery([...CATEGORY.LIST_TREE], () => CategoryApi.getCategoryListTree(search), {
    ...options,
    onSuccess: () => success(categoryToastMsg.GET_CATEGORY_LIST_TREE_SUCCESS),
    onError: (e) => error(categoryToastMsg.GET_CATEGORY_LIST_TREE_ERROR, e),
  });
};

export default useCategoryListTree;
